import { ErrorHandlerProviderProps } from '@sixfold/app-utils';

import { getEmbedConfig } from './data';

const isHeadlessBrowser = /HeadlessChrome/i.test(navigator.userAgent);

const embedConfig = getEmbedConfig();
const sentryOptions: ErrorHandlerProviderProps['sentryOptions'] =
  embedConfig !== null && embedConfig.sentry_dsn
    ? {
        isEnabled: true,
        isHttpClientCaptureEnabled: true,
        dsn: embedConfig.sentry_dsn,
        release: embedConfig.sentry_release,
        environment: embedConfig.sentry_environment,
        thirdPartyErrorFilter: {
          applicationKey: embedConfig.sentry_app_key ?? 'login-web-appkey',
        },
        ignoreErrors: [
          /ResizeObserver loop limit exceeded/,
          /ResizeObserver loop completed with undelivered notifications/,
          // Fix by: https://app.asana.com/0/1202007030618467/1205798219208199
          /Response not successful: Received status code 401/,
        ],
        beforeSend: (event) => {
          if (isHeadlessBrowser) {
            return null;
          }
          return event;
        },
      }
    : { isEnabled: false };

export { sentryOptions };
